import { render, staticRenderFns } from "./ayudaDep.vue?vue&type=template&id=0096429f"
import script from "./ayudaDep.vue?vue&type=script&lang=js"
export * from "./ayudaDep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports